import { useEffect, useState } from "react";
import api from "@/lib/api";

// Single source of truth for per-rodeo Official/Unofficial (server-backed).
// Applies to ALL of the rider's events at that rodeo. Default = Official.
let cache = null;
let loading = null;
const listeners = new Set();

function emit() { listeners.forEach((fn) => fn()); }

export async function loadOfficials() {
  if (loading) return loading;
  loading = api.get("/my/rodeo-officials")
    .then((r) => { cache = r.data || {}; })
    .catch(() => { cache = {}; })
    .finally(() => { loading = null; emit(); });
  return loading;
}

export function officialsReady() { return cache !== null; }
export function isOfficial(id) { return cache ? cache[id] !== false : true; }

export async function setOfficialFlag(id, val) {
  if (!cache) cache = {};
  cache[id] = val;
  emit();
  try { await api.put("/my/rodeo-official", { rodeo_id: id, official: val }); }
  catch { /* keep optimistic value */ }
}

export function subscribe(fn) { listeners.add(fn); return () => listeners.delete(fn); }

// React hook: reactive official flag for one rodeo.
export function useOfficial(id) {
  const [, force] = useState(0);
  useEffect(() => {
    if (!officialsReady()) loadOfficials();
    return subscribe(() => force((x) => x + 1));
  }, []);
  return {
    official: isOfficial(id),
    ready: officialsReady(),
    set: (val) => setOfficialFlag(id, val),
    toggle: () => setOfficialFlag(id, !isOfficial(id)),
  };
}

// React hook: bumps whenever any official flag changes (for list/map filters & memos).
export function useOfficialsVersion() {
  const [v, setV] = useState(0);
  useEffect(() => {
    if (!officialsReady()) loadOfficials();
    return subscribe(() => setV((x) => x + 1));
  }, []);
  return v;
}
